<script setup lang="ts">
import MultiSelect from '@/components/MultiSelect.vue'
import { FormControl, FormDescription, FormField, FormItem, FormMessage } from '@/foundation/form'
import { assignees, categories, clients, labels, ranges, roles } from '@/views/tickets/data/data'
import AutoFormLabel from './AutoFormLabel.vue'
import type { FieldProps } from './interface'
import { beautifyObjectName } from './utils'

const props = defineProps<FieldProps>()
const dataTypes = [...assignees, ...categories, ...clients, ...labels, ...ranges, ...roles]
const getLabel = (labelObject: { id: string; name: string }) => {
  const dataItem = dataTypes.find((s) => s.value === labelObject?.name)

  return dataItem?.label
}
</script>

<template>
  <FormField v-slot="slotProps" :name="fieldName">
    <FormItem v-bind="$attrs">
      <AutoFormLabel v-if="!config?.hideLabel" :required="required">
        {{ config?.label || beautifyObjectName(label ?? fieldName) }}
      </AutoFormLabel>
      <FormControl>
        <slot v-bind="slotProps">
          <MultiSelect
            :disabled="props.disabled"
            v-bind="props.config?.inputProps"
            :value="slotProps.componentField.modelValue"
            :label="getLabel(slotProps.componentField.modelValue) ?? slotProps.componentField.modelValue?.name"
            @update:value="slotProps.componentField['onUpdate:modelValue']"
          />
        </slot>
      </FormControl>
      <FormDescription v-if="config?.description">
        {{ config.description }}
      </FormDescription>
      <FormMessage />
    </FormItem>
  </FormField>
</template>
